import { useState } from 'react';
import { brands } from '@/mocks/brands';
import type { ButterBrand } from '@/mocks/brands';

const compareFields = [
  { key: 'origin' as const, label: '产地' },
  { key: 'type' as const, label: '类型' },
  { key: 'fatContent' as const, label: '乳脂含量' },
  { key: 'priceRange' as const, label: '参考价格' },
  { key: 'rating' as const, label: '评分' },
];

export default function BrandComparison() {
  const [selectedBrands, setSelectedBrands] = useState<ButterBrand[]>(
    brands.slice(0, 4)
  );

  const addBrand = (brand: ButterBrand) => {
    if (selectedBrands.length >= 5) return;
    if (selectedBrands.find((b) => b.id === brand.id)) return;
    setSelectedBrands([...selectedBrands, brand]);
  };

  const removeBrand = (id: string) => {
    if (selectedBrands.length <= 2) return;
    setSelectedBrands(selectedBrands.filter((b) => b.id !== id));
  };

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            热门黄油品牌对比
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            选择2-5个品牌，横向对比关键指标
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-2 mb-6 justify-center">
          {brands.map((brand) => {
            const isSelected = selectedBrands.some((b) => b.id === brand.id);
            return (
              <button
                key={brand.id}
                type="button"
                onClick={() => (isSelected ? removeBrand(brand.id) : addBrand(brand))}
                className={`px-3 py-1.5 text-xs font-medium rounded-full border transition-all whitespace-nowrap cursor-pointer ${
                  isSelected
                    ? 'bg-primary-500 text-white border-primary-500'
                    : 'bg-background-100 text-foreground-600 border-background-200 hover:border-primary-300 hover:text-primary-600'
                }`}
              >
                {brand.name}
              </button>
            );
          })}
        </div>

        <div className="overflow-x-auto">
          <table className="w-full min-w-[640px] border-collapse">
            <thead>
              <tr className="border-b border-background-200">
                <th className="text-left py-3 px-4 text-sm font-semibold text-foreground-700 whitespace-nowrap">
                  品牌
                </th>
                {selectedBrands.map((b) => (
                  <th key={b.id} className="text-center py-3 px-4">
                    <div className="flex flex-col items-center gap-1">
                      <span className="text-sm font-semibold text-foreground-900">
                        {b.originFlag} {b.name}
                      </span>
                      <button
                        type="button"
                        onClick={() => removeBrand(b.id)}
                        className="text-xs text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer"
                      >
                        <i className="ri-close-circle-line"></i>
                      </button>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {compareFields.map((field) => (
                <tr key={field.key} className="border-b border-background-200/70">
                  <td className="py-3 px-4 text-sm font-medium text-foreground-700 whitespace-nowrap">
                    {field.label}
                  </td>
                  {selectedBrands.map((brand) => (
                    <td key={brand.id} className="text-center py-3 px-4">
                      {field.key === 'rating' ? (
                        <span className="inline-flex items-center gap-1 text-sm text-primary-500 font-semibold">
                          <i className="ri-star-fill text-xs"></i>
                          {brand.rating}
                        </span>
                      ) : (
                        <span className="text-sm text-foreground-700">
                          {brand[field.key]}
                        </span>
                      )}
                    </td>
                  ))}
                </tr>
              ))}
              <tr className="border-b border-background-200/70">
                <td className="py-3 px-4 text-sm font-medium text-foreground-700 whitespace-nowrap">
                  特点
                </td>
                {selectedBrands.map((brand) => (
                  <td key={brand.id} className="text-center py-3 px-4">
                    <div className="flex flex-wrap justify-center gap-1">
                      {brand.features.slice(0, 3).map((f, i) => (
                        <span
                          key={i}
                          className="px-1.5 py-0.5 bg-accent-100 text-accent-800 text-xs rounded"
                        >
                          {f}
                        </span>
                      ))}
                    </div>
                  </td>
                ))}
              </tr>
              <tr>
                <td className="py-3 px-4 text-sm font-medium text-foreground-700 whitespace-nowrap">
                  最适合
                </td>
                {selectedBrands.map((brand) => (
                  <td key={brand.id} className="text-center py-3 px-4">
                    <div className="flex flex-wrap justify-center gap-1">
                      {brand.bestFor.map((b, i) => (
                        <span
                          key={i}
                          className="px-1.5 py-0.5 bg-secondary-100 text-secondary-800 text-xs rounded"
                        >
                          {b}
                        </span>
                      ))}
                    </div>
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}